import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV } from "@/lib/content";

export const Header = () => {
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  return (
    <header className="sticky top-0 z-50 bg-bone border-b border-sage/40" data-testid="site-header">
      <div className="mx-auto max-w-6xl px-6 sm:px-8 lg:px-10">
        <div className="flex h-16 items-center justify-between">
          <Link to="/" className="flex items-baseline gap-2" data-testid="logo-link" onClick={() => setOpen(false)}>
            <span className="font-display text-2xl text-spruce leading-none">Health and More</span>
          </Link>

          <nav className="hidden md:flex items-center gap-7" aria-label="Primary">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                data-testid={`nav-${n.to.replace(/\//g, "")}`}
                className={({ isActive }) =>
                  `text-sm transition-colors ${
                    isActive || loc.pathname === n.to
                      ? "text-spruce font-semibold"
                      : "text-ink/80 hover:text-spruce"
                  }`
                }
              >
                {n.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              data-testid="nav-contact-cta"
              className="text-sm font-semibold text-bone bg-spruce px-4 py-2 rounded-[2px] hover:bg-ink transition-colors"
            >
              Talk to us
            </Link>
          </nav>

          <button
            className="md:hidden p-2 text-spruce"
            onClick={() => setOpen((v) => !v)}
            aria-label={open ? "Close menu" : "Open menu"}
            data-testid="mobile-menu-toggle"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-sage/40 bg-bone" data-testid="mobile-menu">
          <div className="px-6 py-4 flex flex-col gap-4">
            {NAV.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${n.to.replace(/\//g, "")}`}
                className="text-base text-ink hover:text-spruce"
              >
                {n.label}
              </Link>
            ))}
            <Link
              to="/contact"
              onClick={() => setOpen(false)}
              data-testid="mobile-nav-contact"
              className="text-base font-semibold text-bone bg-spruce px-4 py-2 rounded-[2px] w-fit"
            >
              Talk to us
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
